import React, { useState, useEffect } from 'react';
import Header from './Components/Header';
import Menu from './Components/Menu';
import { config } from './Components/Config';

const AiSetting = () => {
    const [isAiConversationEnabled, setIsAiConversationEnabled] = useState(false);
    const [isAiCheckinEnabled, setIsAiCheckinEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const crmUser = JSON.parse(localStorage.getItem('crmUser'));

    // Fetch initial state
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await fetch(`${config.EVENT_ENDPOINT}event/ai-setting`);
                const data = await res.json();
                if (data.success) {
                    setIsAiConversationEnabled(data.data.conversation);
                    setIsAiCheckinEnabled(data.data.checkIn);
                }
            } catch (error) {
                console.error("Error fetching AI settings:", error);
            }
        };
        fetchSettings();
    }, []);

    const handleConversationToggle = async () => {
        const newValue = !isAiConversationEnabled;
        setIsAiConversationEnabled(newValue);
        setIsLoading(true);

        try {
            const response = await fetch(`${config.EVENT_ENDPOINT}event/ai-setting/conversation`, {
                method: 'POST', // or 'PUT', adjust according to your backend
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ status: newValue })
            });

            const result = await response.json();
            if (!result.success) {
                // Revert if failed
                setIsAiConversationEnabled(!newValue);
                alert("Failed to update AI Conversation setting");
            }
        } catch (error) {
            console.error("Error updating AI Conversation:", error);
            setIsAiConversationEnabled(!newValue);
            alert("Error updating AI Conversation setting");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCheckinToggle = async () => {
        const newValue = !isAiCheckinEnabled;
        setIsAiCheckinEnabled(newValue);
        setIsLoading(true);

        try {
            const response = await fetch(`${config.EVENT_ENDPOINT}event/ai-setting/checkin`, {
                method: 'POST', // or 'PUT', adjust according to your backend
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ status: newValue })
            });

            const result = await response.json();
            if (!result.success) {
                // Revert if failed
                setIsAiCheckinEnabled(!newValue);
                alert("Failed to update AI Checkin setting");
            }
        } catch (error) {
            console.error("Error updating AI Checkin:", error);
            setIsAiCheckinEnabled(!newValue);
            alert("Error updating AI Checkin setting");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div id="ai-setting-page">
            <div className="container-fluid p-0">
                <div className="row g-0 mh-100vh">
                    <div className="col-md-2 border-end">
                        <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
                            <a className="h-100" href="/dashboard">
                                <img className="h-100" src="/cuancuan.png" alt="PointStar" />
                            </a>
                        </div>
                        <hr className="m-0" />
                        <Menu active="event-ai-setting" />
                    </div>
                    <div className="col-md-10">
                        <Header />
                        <hr className="m-0" />
                        <div className="main">
                            <div className="p-4">
                                <section className="mb-4">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="fs-24">AI Setting</div>
                                    </div>
                                    <div className="bg-white border-radius-4 p-4 shadow-sm">

                                        <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-3">
                                            <div>
                                                <h6 className="mb-1 fw-bold">AI Receptionist Conversation</h6>
                                                <p className="text-muted mb-0 small">Enable or disable the AI receptionist for handling event conversations.</p>
                                            </div>
                                            {crmUser.user_level !== 'View' && (
                                                <div className="form-check form-switch fs-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        id="aiConversationToggle"
                                                        checked={isAiConversationEnabled}
                                                        onChange={handleConversationToggle}
                                                        disabled={isLoading}
                                                        style={{
                                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                                            ...(isAiConversationEnabled && { backgroundColor: '#F9D876', borderColor: '#F9D876' })
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h6 className="mb-1 fw-bold">AI Receptionist Checkin</h6>
                                                <p className="text-muted mb-0 small">Enable or disable the AI receptionist for event check-in processes.</p>
                                            </div>
                                            {crmUser.user_level !== 'View' && (
                                                <div className="form-check form-switch fs-4">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        role="switch"
                                                        id="aiCheckinToggle"
                                                        checked={isAiCheckinEnabled}
                                                        onChange={handleCheckinToggle}
                                                        disabled={isLoading}
                                                        style={{
                                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                                            ...(isAiCheckinEnabled && { backgroundColor: '#F9D876', borderColor: '#F9D876' })
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AiSetting;


